/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OperatorKnoten } from './OperatorKnoten';
import {
    instanceOfOperatorKnoten,
    OperatorKnotenFromJSON,
    OperatorKnotenFromJSONTyped,
    OperatorKnotenToJSON,
} from './OperatorKnoten';
import type { ParameterKnoten } from './ParameterKnoten';
import {
    instanceOfParameterKnoten,
    ParameterKnotenFromJSON,
    ParameterKnotenFromJSONTyped,
    ParameterKnotenToJSON,
} from './ParameterKnoten';

/**
 * @type BerechnungsKnoten
 * Ein Knoten ist entweder ein Berechnungsoperator, oder ein Parameter. Über die Knoten wird ein Berechnungsmodell abgebildet.
 * @export
 */
export type BerechnungsKnoten = OperatorKnoten | ParameterKnoten;

export function BerechnungsKnotenFromJSON(json: any): BerechnungsKnoten {
    return BerechnungsKnotenFromJSONTyped(json, false);
}

export function BerechnungsKnotenFromJSONTyped(json: any, ignoreDiscriminator: boolean): BerechnungsKnoten {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...OperatorKnotenFromJSONTyped(json, true), ...ParameterKnotenFromJSONTyped(json, true) };
}

export function BerechnungsKnotenToJSON(value?: BerechnungsKnoten | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfOperatorKnoten(value)) {
        return OperatorKnotenToJSON(value as OperatorKnoten);
    }
    if (instanceOfParameterKnoten(value)) {
        return ParameterKnotenToJSON(value as ParameterKnoten);
    }

    return {};
}

